<script setup lang="ts">
import draggable from 'vuedraggable';
import { storeToRefs } from 'pinia';
import { getBlock } from '@/core/block-registry';
import { ContentBlock } from '@/modules/content-blocks/interfaces';
import JobBoardFooter from '@/modules/content-blocks/components/views/JobBoardFooter.vue';
import JobBoardHeader from '@/modules/content-blocks/components/views/JobBoardHeader.vue';
import BlockPreview from '@/modules/live-editor/components/content-blocks/BlockPreview.vue';
import { useLiveEditorStore } from '@/modules/live-editor/stores/live-editor.store';

const { blocks, editingBlock } = storeToRefs(useLiveEditorStore());

function isBlockSelected(element: ContentBlock) {
   return editingBlock.value?.id === element.id;
}
</script>

<template>
   <section>
      <JobBoardHeader />
      <draggable v-model="blocks" :group="`blocks`" :handle="`.content-block-container__action-bar-drag`" item-key="id">
         <template #item="{ element }">
            <BlockPreview
               v-if="getBlock(element.type)"
               :block-definition="getBlock(element.type)"
               :id="element.id"
               :data="element.data"
               :isSelected="isBlockSelected(element)"
               v-bind="$attrs"
            />
         </template>
      </draggable>
      <JobBoardFooter />
   </section>
</template>

<style scoped lang="scss">
section {
   font-family: var(--jobsite-font-family, inherit);

   :deep(.nxt-dropdown) {
      .nxt-dropdown__list-item {
         &.-selected {
            background-color: var(--nxt-extralight-grey);
            color: inherit;
         }

         &:hover {
            background-color: var(--nxt-light-grey);
            color: inherit;
         }
      }
   }
}
</style>
